import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=585fca69&scoped=true"
import script from "./messageItem.vue?vue&type=script&lang=js"
export * from "./messageItem.vue?vue&type=script&lang=js"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=585fca69&prod&lang=scss&scoped=true"
import style1 from "./messageItem.vue?vue&type=style&index=1&id=585fca69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fca69",
  null
  
)

export default component.exports